import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../core/services/language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pomotionn-info',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './pomotionn-info.component.html',
  styleUrl: './pomotionn-info.component.css'
})
export class PomotionnInfoComponent implements OnInit, OnDestroy {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;
  
  searchQuery: string = '';
  selectedTab: 'all' | 'promo' | 'news' = 'all';
  selectedPromo: any = null; // Holds the promotion selected for detail modal

  promotions = [
    {
      id: 1,
      image: '/images/Advert/cover photo site parking-01.png',
      tag: 'promo',
      tagTH: 'โปรโมชั่น',
      tagEN: 'PROMO',
      date: '2026-07-16',
      titleTH: 'ลดค่าจอดรถ 50%',
      titleEN: '50% Parking Discount',
      discountTH: 'เมื่อสมัครจอดรายเดือนครั้งแรก',
      discountEN: 'For first-time monthly parking',
      detailTH: 'โปรโมชั่นต้อนรับสมาชิกใหม่! รับส่วนลดค่าจอดรถทันที 50% สำหรับการสมัครที่จอดรถรายเดือนในครั้งแรกที่เข้าร่วมโครงการกับทาง City Parking สิทธิ์มีจำนวนจำกัดกรุณาลงทะเบียนผ่านหน้าเมนูบัตรสมาชิก',
      detailEN: 'Welcome new members! Receive an instant 50% discount on your first monthly parking subscription. Limited privileges available. Register via the member card menu.',
      termsTH: '1. สำหรับสมาชิกใหม่เท่านั้น\n2. จำกัด 1 สิทธิ์ต่อ 1 ผู้ใช้งาน\n3. โปรโมชั่นสิ้นสุดวันที่ 31 ธันวาคม 2569',
      termsEN: '1. For new members only.\n2. Limit 1 privilege per user.\n3. Promotion ends December 31, 2026.'
    },
    {
      id: 2,
      image: '/images/Advert/cover photo site parking-02.png',
      tag: 'promo',
      tagTH: 'โปรโมชั่น',
      tagEN: 'PROMO',
      date: '2026-07-15',
      titleTH: 'ชาร์จ EV รับพอยท์ 2 เท่า',
      titleEN: 'Get 2x Points on EV charging',
      discountTH: 'สะสมคะแนนเพิ่มขึ้นสะดวกรวดเร็ว',
      discountEN: 'Earn more points today',
      detailTH: 'เพียงใช้บริการสถานีชาร์จรถยนต์ไฟฟ้า EV Charger ในเครือข่ายของเรา รับคะแนนสะสมพิเศษ x2 เพื่อแลกรับของรางวัล หรือส่วนลดค่าบริการจอดรถในครั้งถัดไป',
      detailEN: 'Use our EV charging stations and get 2x points to redeem rewards or future parking discounts.',
      termsTH: '1. คะแนนสะสมจะคำนวณและปรับอัตโนมัติภายใน 24 ชม.\n2. เงื่อนไขเป็นไปตามที่บริษัทฯ กำหนด',
      termsEN: '1. Points calculated and adjusted automatically within 24 hours.\n2. Terms and conditions apply.'
    },
    {
      id: 3,
      image: '/images/Advert/AdvertEvCharger.png',
      tag: 'news',
      tagTH: 'ข่าวสาร',
      tagEN: 'NEWS',
      date: '2026-07-10',
      titleTH: 'เปิดจุดบริการ EV Charger ใหม่',
      titleEN: 'New EV Charger Stations Open',
      discountTH: 'เปิดตัวสถานีชาร์จความเร็วสูง 3 จุดใหม่',
      discountEN: 'Launching 3 new DC fast charger stations',
      detailTH: 'เพิ่มความสะดวกสบายยิ่งขึ้น! เปิดให้บริการจุดชาร์จรถไฟฟ้าความเร็วสูงพิเศษ (DC Fast Charge) ใหม่ล่าสุด 3 สถานีในย่านธุรกิจใจกลางกรุง สามารถตรวจสอบสถานะการชาร์จผ่านทางแอปได้เลย',
      detailEN: 'More convenience! Presenting 3 new high-speed DC Fast Charging stations in metropolitan business centers. Monitor charging status live in our app.',
      termsTH: 'เปิดให้บริการแล้ววันนี้ตลอด 24 ชั่วโมง',
      termsEN: 'Open now 24/7'
    },
    {
      id: 4,
      image: '/images/Advert/cover photo site parking-01.png',
      tag: 'news',
      tagTH: 'ข่าวสาร',
      tagEN: 'NEWS',
      date: '2026-07-05',
      titleTH: 'ขยายเวลารับสิทธิ์จอดรถพิเศษ VIP',
      titleEN: 'Extended VIP Parking Access',
      discountTH: 'รับของขวัญพิเศษประจำเดือน',
      discountEN: 'Get monthly special gift',
      detailTH: 'ข่าวดียืนยันการขยายเวลาสิทธิ์จอดรถช่องพิเศษสำหรับลูกค้า VIP ต่อเนื่องไปจนถึงสิ้นปี เพื่อแทนคำขอบคุณผู้ใช้บริการอย่างต่อเนื่อง',
      detailEN: 'Great news! We are extending exclusive VIP parking access through the end of the year to thank our regular patrons.',
      termsTH: 'สำหรับลูกค้าที่มีระดับสมาชิก VIP เท่านั้น',
      termsEN: 'For customers with VIP tier status only.'
    }
  ];

  constructor(
    private router: Router,
    private location: Location,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  /* ================= Normal Functions ================= */

  // Navigate back to the previous screen
  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/home']);
    }
  }

  // Switch filter category tab
  changeTab(tab: 'all' | 'promo' | 'news') {
    this.selectedTab = tab;
  }

  // Open detailed popup
  openDetail(promo: any) {
    this.selectedPromo = promo;
  }

  // Close detailed popup
  closeDetail() {
    this.selectedPromo = null;
  }

  // Live filter promotions list based on category and search text
  get filteredPromotions() {
    let list = this.promotions;
    
    // Category tab filter
    if (this.selectedTab !== 'all') {
      list = list.filter(item => item.tag === this.selectedTab);
    }

    // Text search query filter
    const query = this.searchQuery.trim().toLowerCase();
    if (query) {
      list = list.filter(item => {
        const title = this.currentLang === 'TH' ? item.titleTH : item.titleEN;
        const discount = this.currentLang === 'TH' ? item.discountTH : item.discountEN;
        const detail = this.currentLang === 'TH' ? item.detailTH : item.detailEN;
        return (
          title.toLowerCase().includes(query) ||
          discount.toLowerCase().includes(query) ||
          detail.toLowerCase().includes(query)
        );
      });
    }

    return list;
  }
}
